<p-toast />
<div class="card">
    <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="start">
            <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" (onClick)="backToSupport()" />
        </ng-template>
        <ng-template pTemplate="center">
            <span class="font-semibold text-xl">Dispute {{ claimNumber }}</span>
        </ng-template>
        <ng-template pTemplate="end">
            <p-button
                *ngIf="detail?.orderNumber"
                label="View order"
                icon="pi pi-shopping-cart"
                severity="secondary"
                (onClick)="openOrder()"
            />
        </ng-template>
    </p-toolbar>

    <div *ngIf="loading" class="p-4 text-center">Loading dispute...</div>

    <ng-container *ngIf="!loading && detail">
        <div class="summary-grid mb-4 p-3 border-round">
            <div><strong>Status:</strong> <p-tag [value]="detail.status" /></div>
            <div><strong>Type:</strong> {{ detail.claimType }}</div>
            <div><strong>Order:</strong> {{ detail.orderNumber }}</div>
            <div><strong>Invoice:</strong> {{ detail.invoiceNumber || '—' }}</div>
            <div><strong>Created:</strong> {{ detail.createdAt | date: 'medium' }}</div>
            <div *ngIf="detail.updatedAt"><strong>Updated:</strong> {{ detail.updatedAt | date: 'medium' }}</div>
            <div *ngIf="detail.totalClaimQty != null"><strong>Claim qty:</strong> {{ detail.totalClaimQty }}</div>
            <div *ngIf="detail.totalClaimAmount != null">
                <strong>Claim amount:</strong> {{ detail.totalClaimAmount }}
            </div>
        </div>

        <div *ngIf="detail.customerComment" class="mb-4 p-3 border-round comment-box">
            <strong>Customer comment</strong>
            <p class="m-0 mt-2">{{ detail.customerComment }}</p>
        </div>

        <h3 class="section-title">Disputed lines</h3>
        <p-table [value]="detail.lines || []" responsiveLayout="scroll" styleClass="mb-4">
            <ng-template pTemplate="header">
                <tr>
                    <th>Item #</th>
                    <th>Name</th>
                    <th>Ordered</th>
                    <th>Claimed</th>
                    <th>Approved</th>
                    <th>Reason</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-line>
                <tr>
                    <td>{{ line.itemNumber }}</td>
                    <td>{{ line.itemName }}</td>
                    <td>{{ line.orderedQty }}</td>
                    <td>{{ line.claimedQty }}</td>
                    <td>{{ line.approvedQty ?? '—' }}</td>
                    <td>{{ line.reason }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">No disputed lines.</td>
                </tr>
            </ng-template>
        </p-table>

        <h3 class="section-title" *ngIf="detail.attachments?.length">Attachments</h3>
        <ul *ngIf="detail.attachments?.length" class="attachment-list mb-4">
            <li *ngFor="let a of detail.attachments">
                {{ a.originalFileName }} ({{ formatFileSize(a.fileSize) }}) — {{ a.contentType }}
            </li>
        </ul>

        <h3 class="section-title" *ngIf="detail.creditNotes?.length">Credit notes</h3>
        <ul *ngIf="detail.creditNotes?.length" class="mb-4">
            <li *ngFor="let cn of detail.creditNotes">
                {{ cn.creditNoteOrderNumber }} ({{ cn.creditNoteOrderType }})
                <span *ngIf="cn.createdAt"> — {{ cn.createdAt | date: 'medium' }}</span>
            </li>
        </ul>

        <h3 class="section-title" *ngIf="detail.timeline?.length">Timeline</h3>
        <p-table *ngIf="detail.timeline?.length" [value]="detail.timeline" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>When</th>
                    <th>From</th>
                    <th>To</th>
                    <th>By</th>
                    <th>Comment</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-event>
                <tr>
                    <td>{{ event.changedAt | date: 'medium' }}</td>
                    <td>{{ event.oldStatus || '—' }}</td>
                    <td>{{ event.newStatus }}</td>
                    <td>{{ event.changedBy || '—' }}</td>
                    <td>{{ event.comment || '—' }}</td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>
</div>
